/**
 * 維修品項 list query → API params。
 * - sort id：camel → snake（BE 白名單為 snake）
 * - 多選欄（含 status）：陣列改單一 `status=PENDING,REPAIRED` 逗號 OR；BE 對重複 key 回 400
 */
import {
  DEFAULT_LIST_PAGE,
  DEFAULT_LIST_PAGE_SIZE,
} from '#/utils/listUrl/listPaginationDefaults';

function toSnakeKey(key) {
  return String(key ?? '').replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
}

/**
 * @param {object} listQuery
 * @returns {URLSearchParams}
 */
export function listQueryToRepairItemApiParams(listQuery) {
  const params = new URLSearchParams();
  params.set('page', String(listQuery?.page || DEFAULT_LIST_PAGE));
  params.set('page_size', String(listQuery?.pageSize || DEFAULT_LIST_PAGE_SIZE));

  if (listQuery?.keyword) {
    params.set('keyword', listQuery.keyword);
  }

  (listQuery?.sort || []).forEach(({ id, desc }) => {
    if (!id) {
      return;
    }
    params.append('sort', `${toSnakeKey(id)},${desc ? 'desc' : 'asc'}`);
  });

  Object.entries(listQuery?.filters || {}).forEach(([key, value]) => {
    const snakeKey = toSnakeKey(key);

    if (Array.isArray(value)) {
      const values = value
        .map((item) => String(item ?? '').trim())
        .filter(Boolean);
      if (values.length > 0) {
        params.set(snakeKey, values.join(','));
      }
      return;
    }

    if (value) {
      params.set(snakeKey, value);
    }
  });

  return params;
}
